<template>
    <div style='box-sizing: border-box'>
        <el-container style='position: relative;'>
            <el-header class='header-menu' height='48px'>
                <cotton-header/>
            </el-header>
            <el-main style='background-color: #f9f9f9'>
                <cotton-main-box/>
            </el-main>
            <el-footer height='100%' class='cotton-footer'>
                <cotton-footer/>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import bus from './bus';
import CottonHeader from '@/components/common/Header.vue';
import CottonMainBox from '@/components/common/MainBox.vue';
import CottonFooter from '@/components/common/Footer.vue';

export default {
    name: "CottonHome",
    data() {
        return {
            tagsList: [],
            collapse: false
        };
    },
    components: {
        CottonFooter,
        CottonMainBox,
        CottonHeader
        
    },
    created() {
        bus.$on('collapse-content', msg => {
            this.collapse = msg;
        });

        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
        bus.$on('tags', msg => {
            let arr = [];
            for (let i = 0, len = msg.length; i < len; i++) {
                msg[i].name && arr.push(msg[i].name);
            }
            this.tagsList = arr;
        });
    },
    methods: {
    }
};
</script>
<style scoped lang='css'>
.header-menu {
    width: 100%;
    height: 100%;
    background-color: #0e78ce;
    color: #f2f2f2;
    
    line-height: 48px;
    white-space: nowrap;
    padding: 0 3rem;
}

.cotton-footer {
    background-color: #ebedf0;
    border: 1px solid #ebedf0;
    padding: 0 3rem;
}
</style>